import { $applyNodeReplacement, LexicalNode } from 'lexical';

import { QuoteNode } from './QuoteNode';

export function $createQuoteNode(text: string, author: string): QuoteNode {
  return $applyNodeReplacement(new QuoteNode(text, author));
}

export function $isQuoteNode(
  node: LexicalNode | null | undefined,
): node is QuoteNode {
  return node instanceof QuoteNode;
}
